import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { initAnalytics } from "@/utils/analytics";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import AskQuestion from "@/pages/Domanda";
import Privacy from "@/pages/Privacy";
import CookiePolicy from "@/pages/CookiePolicy";
import ChiSiamo from "@/pages/ChiSiamo";
import Contatti from "@/pages/Contatti";
import Termini from "@/pages/Termini";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import NotFound from "@/pages/NotFound";
import CookieBanner from "@/components/CookieBanner";
import ScrollToTop from "@/components/ScrollToTop";
import ScrollToTopOnNavigate from "@/components/ScrollToTopOnNavigate";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground" data-testid="auth-loading">
        Caricamento…
      </div>
    );
  }
  if (user === false) return <Navigate to="/admin" replace />;
  return children;
}

function App() {
  useEffect(() => {
    initAnalytics();
  }, []);
  return (
    <div className="App min-h-screen bg-foreground p-4 sm:p-6 md:p-8">
      <div
        className="min-h-[calc(100vh-2rem)] overflow-hidden rounded-2xl bg-background sm:min-h-[calc(100vh-3rem)] md:min-h-[calc(100vh-4rem)]"
        data-testid="site-frame"
      >
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTopOnNavigate />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/fai-una-domanda" element={<AskQuestion />} />
            <Route path="/guide" element={<Navigate to="/" replace />} />
            <Route path="/chi-siamo" element={<ChiSiamo />} />
            <Route path="/contatti" element={<Contatti />} />
            <Route path="/termini" element={<Termini />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<Protected><AdminDashboard /></Protected>} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <CookieBanner />
          <ScrollToTop />
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
      </div>
    </div>
  );
}

export default App;
